import { Permissions } from './../../../../core/constants/permissions';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SiteList } from "../../../../core/models/site-list.model";
import { SiteService } from "../../../../core/services/site.service";
import { TrialService } from "../../../../core/services/trial.service";
import { AuthService } from "../../../../core/services/auth.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { ModalComponent } from "../../../../shared/modal/modal.component";

@Component({
  selector: 'app-trial-sites',
  templateUrl: './trial-sites.component.html',
  styleUrls: ['./trial-sites.component.scss']
})
export class TrialSitesComponent implements OnInit, OnChanges {
  @ViewChild('unassignSiteModel') unassignSiteModel: ModalComponent;

  @Input() trialId: string;
  @Input('apiEnabled') apiEnabled: boolean = false;

  results = new SiteList();
  siteIsUnassigning = false;
  unassignSiteId = '';
  Permissions = Permissions;
  dataLoaded: boolean = false;
  loaderArray: number[] = [1,1,1,1,1,1,1,1,1,1];

  searchForm = new FormGroup({
    searchInput: new FormControl<string>(null)
  });

  constructor(public authService: AuthService, private readonly siteService: SiteService, private readonly alertService: AlertService, private readonly trialService: TrialService) { }

  ngOnInit() {
    this.searchForm.controls.searchInput.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((searchInput: string) => {
        this.loadSites(1, searchInput ? searchInput.toLowerCase() : null);
      });
  }

  loadSites(pageNo: number = 1, keywords: string = null) {
    if (this.trialId != null) {
      this.dataLoaded = false;
      this.siteService.retrieveSites(pageNo, this.trialId, keywords, null).subscribe({
        next: siteList => {
          this.results = siteList;
          this.dataLoaded = true;
        },
        error: () => {
          this.dataLoaded = true;
          this.alertService.showWarningAlert('There was a problem loading sites!');
        }
      });
    }
  }

  mapStatus(int: number) {
    switch (int) {
      case 0:
        return "Pending"
      case 1:
        return "Approved"
      case 2:
        return "Declined"
      default:
        break;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const trialIdChange = changes['trialId'];

    if (!trialIdChange || trialIdChange.currentValue == null || trialIdChange.currentValue === '') {
      return;
    }

    if (trialIdChange.firstChange || trialIdChange.previousValue !== trialIdChange.currentValue) {
      this.loadSites();
    }
  }

  onUnassignSite(siteId: string) {
    this.unassignSiteId = siteId;
    this.unassignSiteModel.show();
  }

  onConfirmUnassignSite() {
    this.trialService.unassignSite(this.trialId, this.unassignSiteId).subscribe({
      next: () => {
        this.unassignSiteId = '';
        this.unassignSiteModel.hide();
        this.loadSites(1);
        this.alertService.showSuccessAlert('Site has been unassigned.');
      },
      error: error => {
        this.alertService.showWarningAlert(error.error ? error.error.title : 'Sorry there was a problem unassigning the site.');
      }
    });
  }
}
